import { Injectable, OnDestroy } from '@angular/core';
import { HttpHeaderService } from 'src/app/shared/service/http-header.service';
import { HttpClient } from '@angular/common/http';
import { HttpClientAbstract } from 'src/app/shared/service/http-client-abstract';
import { ToastrService } from 'ngx-toastr';
import { CompanyService } from 'src/app/shared/service/company.service';
import { SyncToStgService } from 'src/app/shared/service/sync-to-stg.service';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserRegistrationService extends HttpClientAbstract implements OnDestroy {
  private subscriptions: Subscription = new Subscription();

  constructor(
    header: HttpHeaderService,
    http: HttpClient,
    private toastrService: ToastrService,
    private companyService: CompanyService,
    private syncToStgService: SyncToStgService
  ) {
    super(header, http);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public createNewUsers(data: any, server: string = '') {
    // unpack form data
    let { company_id, company_stg_id, company_detail, users } = data;

    company_id = server === '_STG2' ? company_stg_id : company_id;

    if (company_id === '-1') {
      const service =
        server === '_STG2' ? this.syncToStgService : this.companyService;

      const createCompanySub = service.createNewCompany(company_detail).subscribe({
        next: new_company => {
          company_id = new_company.body['id'];
          this.toastrService.success(server + '会社登録成功');
          this.newUsers(Number(company_id), users, server);
        },
        error: err => {
          this.toastrService.warning(server + '会社登録失敗');
          this.toastrService.warning(
            server + err['error']['errors']['full_messages'].join('\n')
          );
          console.warn(
            server + err['error']['errors']['full_messages'].join('\n')
          );
        }
      });
      this.subscriptions.add(createCompanySub);
    } else {
      this.newUsers(Number(company_id), users, server);
    }
  }

  public newUsers(company: number, users: object[], server: string = '') {
    for (let user of users) {
      user['company_id'] = company;
      const post =
        server === '_STG2'
          ? this.syncToStgService.requestPost_STG2('api/v1/auth', user)
          : super.requestPost('api/v1/auth', user);

      const newUserSub = post.subscribe({
        next: x => {
          this.toastrService.success(
            server + user['name'] + '   ユーザー登録成功'
          );
        },
        error: err => {
          this.toastrService.warning(
            server + user['name'] + '  ユーザー登録失敗'
          );
          console.warn(err);
          this.toastrService.warning(
            server + err['error']['errors']['full_messages'].join('\n')
          );
          console.warn(
            server + err['error']['errors']['full_messages'].join('\n')
          );
        }
      });
      this.subscriptions.add(newUserSub);
    }
  }

  getUserList() {
    return super.requestGet('api/v1/users');
  }
  freezeUser(id: number) {
    return super.requestPost('api/v1/users/freeze_user', { id: id });
  }
}
